export default "__VITE_ASSET__5vlO_p2Y__"